
(() => {
  const states = new Map();
  let stickyTarget,stickyFrame=0;
  const updateStickyVisibility=()=>{
    const sticky=document.querySelector('[data-rs-sticky]');
    if(!sticky) return;
    const footer=document.querySelector('.shopify-section--footer');
    sticky.hidden=!stickyTarget?.isConnected||stickyTarget.getBoundingClientRect().bottom>0||(footer&&footer.getBoundingClientRect().top<=innerHeight);
  };
  window.addEventListener('scroll',()=>{
    if(stickyFrame) return;
    stickyFrame=requestAnimationFrame(()=>{stickyFrame=0;updateStickyVisibility();});
  },{passive:true});
  window.addEventListener('resize',updateStickyVisibility);
  const cfg = () => JSON.parse(document.getElementById('rs-accessory-config')?.textContent || '{}');
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'sv', {style:'currency',currency:window.Shopify.currency.active,minimumFractionDigits:cents % 100 ? 2 : 0,maximumFractionDigits:2}).format(cents/100);
  const panelFor = card => document.getElementById(card.dataset.panelId || card.querySelector('[aria-controls]')?.getAttribute('aria-controls'));
  const cardFor = target => target.closest('[data-accessory]') || (target.closest('.rs-accessory-panel') ? Array.from(document.querySelectorAll('[data-accessory]')).find(c=>c.dataset.panelId===target.closest('.rs-accessory-panel').getAttribute('id')) : null);
  const stateKey = el => el.dataset.sourceProduct;
  const screenState = el => {
    const key=stateKey(el);
    if(!states.has(key)) states.set(key,{included:false,manual:false,value:''});
    return states.get(key);
  };
  const aliases = value => {
    const clean=(value||'').toLowerCase().replace(/\s+/g,'');
    const prefix=clean.match(/^(iphone|samsunggalaxy|galaxy|pixel)/)?.[0]||'';
    return clean.split('/').map(p=>/^(iphone|samsung|galaxy|pixel)/.test(p)?p:prefix+p);
  };
  const matches = (a,b) => aliases(a).some(v=>aliases(b).includes(v));
  const selectVariant = (card,value,manual=false) => {
    const select=card.querySelector('[data-accessory-select]');
    const option=Array.from(select.options).find(o=>o.value===String(value));
    if(!option) return;
    select.value=option.value;
    const label=card.querySelector('[data-accessory-label]');
    const text=option.value?option.dataset.title:(card.dataset.kind==='screen'?cfg().choose_model:'');
    if(label.textContent!==text) label.textContent=text;
    if(option.value) {
      const cents=Number(option.dataset.price), compare=Number(option.dataset.comparePrice);
      const discounted=card.dataset.kind!=='screen' && compare>cents;
      for(const e of [...card.querySelectorAll('[data-accessory-price]'),...panelFor(card).querySelectorAll('[data-panel-price]')]) {
        const plus=card.hasAttribute('data-inline-screen')&&e.hasAttribute('data-accessory-price')?'+':'';
        const state=[cents,compare,discounted,plus].join('|');
        if(e.dataset.priceState===state) continue;
        e.dataset.priceState=state;
        const current=document.createElement('span'),label=document.createElement('span'),amount=document.createElement('span');
        current.className=discounted?'text-on-sale':'text-subdued';
        label.className='sr-only';label.textContent=(discounted?card.dataset.priceSale:card.dataset.priceRegular)+': ';
        amount.textContent=plus+money(cents);current.append(label,amount);e.replaceChildren(current);
        if(discounted) {
          const previous=document.createElement('span'),previousLabel=document.createElement('span'),previousAmount=document.createElement('s');
          previous.className='text-subdued';previousLabel.className='sr-only';previousLabel.textContent=card.dataset.priceCompare+': ';
          previousAmount.textContent=money(compare);previous.append(previousLabel,previousAmount);e.append(document.createTextNode(' '),previous);
        }
      }
    }
    if(card.hasAttribute('data-inline-screen')){
      const choose=card.querySelector('.rs-accessory__choose');
      const prompt=option.value?card.dataset.changeModel:cfg().choose_model;
      if(choose&&choose.textContent!==prompt) choose.textContent=prompt;
    }
    const direct=card.querySelector('[data-accessory-direct]');
    if(direct) direct.disabled=!option.value;
    const confirm=panelFor(card).querySelector('[data-accessory-confirm]');
    confirm.disabled=!option.value;
    const panelModel=panelFor(card).querySelector('[data-panel-model]');
    if(panelModel) panelModel.value=option.value;
    const box=card.querySelector('[data-screen-include]');
    if(box){
      const state=screenState(card);
      state.value=option.value;
      if(manual) state.manual=true;
      box.disabled=!option.value;
      box.checked=state.included && !!option.value;
    }
    updatePurchase();
  };
  async function addItems(items){
    const response=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
    const data=await response.json();
    if(!response.ok) throw new Error(data.description||cfg().error);
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    return data;
  }
  function mainForm(){
    const card=document.querySelector('[data-inline-screen]');
    return card?document.getElementById(card.dataset.productForm):null;
  }
  function purchaseData(){
    const form=mainForm(), card=document.querySelector('[data-inline-screen]');
    if(!form||!card) return null;
    const picker=Array.from(document.querySelectorAll('variant-picker')).find(p=>p.getAttribute('form-id')===form.getAttribute('id'));
    let variant={};
    try{variant=JSON.parse(picker?.querySelector('[data-variant]')?.textContent||'{}');}catch{}
    const qty=Number(form.elements.quantity?.value||1);
    const opt=card.querySelector('[data-accessory-select]').selectedOptions[0];
    const state=screenState(card);
    const confirmed=form.dataset.phoneModelConfirmed==='true';
    const total=Number(variant.price||0)*qty+(state.included&&opt.value?Number(opt.dataset.price):0);
    return {form,card,variant,qty,state,opt,confirmed,total,model:picker?.querySelector('[data-product-model-value]')?.textContent||''};
  }
  function updatePurchase(){
    const data=purchaseData(); if(!data) return;
    const title=data.card.querySelector('[data-screen-title]');
    const selected=data.state.included&&!!data.opt.value;
    if(title){
      const text=selected?title.dataset.added:title.dataset.add;
      if(title.textContent!==text) title.textContent=text;
    }
    const button=data.form.querySelector('button[type=submit]');
    if(button&&data.confirmed&&!button.disabled&&data.variant.price){
      const label=cfg().add+' · '+money(data.total);
      if(button.textContent!==label) button.textContent=label;
    }
    const sticky=document.querySelector('[data-rs-sticky]');
    if(sticky){
      const button=sticky.querySelector('button');
      button.disabled=!data.confirmed||!!data.form.querySelector('button[type=submit]')?.disabled;
      const text=data.confirmed?cfg().add+' · '+money(data.total):cfg().choose_model;
      if(button.textContent!==text) button.textContent=text;
      const label=sticky.querySelector('span');
      if(label.textContent!==data.model) label.textContent=data.model;
    }
  }
  function syncScreen(){
    document.querySelectorAll('[data-inline-screen]').forEach(card=>{
      const form=document.getElementById(card.dataset.productForm);
      const picker=Array.from(document.querySelectorAll('variant-picker')).find(p=>p.getAttribute('form-id')===form?.getAttribute('id'));
      const state=screenState(card), select=card.querySelector('[data-accessory-select]');
      if(state.manual){
        selectVariant(card,state.value);
      }else{
        const model=form?.dataset.phoneModelConfirmed==='true'?picker?.querySelector('[data-product-model-value]')?.textContent:'';
        const option=Array.from(select.options).find(o=>o.value&&model&&matches(o.dataset.title,model));
        selectVariant(card,option?.value||'');
      }
      card.querySelector('[data-screen-include]').checked=state.included&&!!select.value;
    });
    updatePurchase();
  }
  function formatShippingMessages(){
    if(window.Shopify?.currency?.active !== 'SEK') return;
    document.querySelectorAll('[data-free-shipping-message]').forEach(el=>{
      const format=()=>{
        const current=el.textContent;
        const formatted=current.replace(/(\d[\d \u00a0\u202f]*(?:[,.]\d{1,2})?)\s*(?:kr|SEK)\b/g,(_,amount)=>{
          const cents=Math.round(Number(amount.replace(/[\s\u00a0\u202f]/g,'').replace(',','.'))*100);
          return Number.isFinite(cents)?money(cents):_;
        });
        if(formatted!==current) el.textContent=formatted;
      };
      format();
      if(!el.dataset.rsMoneyBound){
        el.dataset.rsMoneyBound='true';
        new MutationObserver(format).observe(el,{childList:true,subtree:true,characterData:true});
      }
    });
  }
  function init(){
    formatShippingMessages();
    document.body.classList.toggle('rs-cart-open',!!document.getElementById('cart-drawer')?.hasAttribute('open'));
    document.querySelectorAll('[data-rs-money]').forEach(el=>{const value=money(Number(el.dataset.rsMoney));if(el.textContent!==value)el.textContent=value;});
    document.querySelectorAll('[data-accessory]:not([data-rs-bound])').forEach(card=>{
      card.dataset.rsBound='true';
      if(!card.hasAttribute('data-inline-screen')) selectVariant(card,card.querySelector('[data-accessory-select]').value);
      card.dataset.panelId=card.querySelector('[aria-controls]').getAttribute('aria-controls');
      const modal=panelFor(card);
      modal.addEventListener('dialog:after-show',()=>{
        document.body.classList.add('rs-accessory-open');
        panelFor(card).querySelector('[data-accessory-confirm]').disabled=!card.querySelector('[data-accessory-select]').value;
      });
      modal.addEventListener('dialog:after-hide',()=>document.body.classList.remove('rs-accessory-open'));
    });
    const form=mainForm();
    if(form&&!form.dataset.rsBundleBound){
      form.dataset.rsBundleBound='true';
      form.addEventListener('change',updatePurchase);
      form.addEventListener('submit',async event=>{
        const data=purchaseData();
        if(!data?.state.included||!data.opt.value||!data.confirmed) return;
        event.preventDefault(); event.stopImmediatePropagation();
        if(form.dataset.rsBusy==='true') return;
        const button=form.querySelector('button[type=submit]');
        form.dataset.rsBusy='true'; button.disabled=true;
        try{
          const fd=new FormData(form), properties={};
          for(const [key,value] of fd) if(key.startsWith('properties[')) properties[key.slice(11,-1)]=value;
          const main={id:Number(fd.get('id')),quantity:data.qty,properties};
          if(fd.get('selling_plan')) main.selling_plan=fd.get('selling_plan');
          await addItems([main,{id:Number(data.opt.value),quantity:1}]);
          document.getElementById('cart-drawer')?.show?.();
        }catch(error){
          const err=panelFor(data.card).querySelector('[data-accessory-error]');err.textContent=error.message;err.hidden=false;
          const status=data.card.querySelector('[data-inline-error]');if(status){status.textContent=error.message;status.hidden=false;}
        }finally{form.dataset.rsBusy='false';button.disabled=false;updatePurchase();}
      },true);
      let sticky=document.querySelector('[data-rs-sticky]');
      if(!sticky){
        sticky=document.createElement('div');sticky.className='rs-product-sticky';sticky.dataset.rsSticky='';
        sticky.hidden=true;sticky.innerHTML='<span></span><button type="button" class="button"></button>';
        document.body.appendChild(sticky);
        sticky.querySelector('button').addEventListener('click',()=>mainForm()?.requestSubmit());
      }

    }
    stickyTarget=mainForm()?.closest('.quantity-and-buttons');
    updateStickyVisibility();
    syncScreen();
  }
  document.addEventListener('input',event=>{if(event.target.matches('input[name="quantity"]')&&event.target.form===mainForm())updatePurchase();});
  document.addEventListener('change',event=>{
    if(event.target.matches('input[name="quantity"]')&&event.target.form===mainForm())updatePurchase();
    const card=cardFor(event.target);if(!card) return;
    if(event.target.matches('[data-panel-option],[data-panel-model]')) selectVariant(card,event.target.value,true);
    if(event.target.matches('[data-screen-include]')){
      screenState(card).included=event.target.checked; updatePurchase();
    }
  });
  document.addEventListener('click',async event=>{
    if(event.target.closest('[aria-controls="cart-drawer"]'))document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
    const button=event.target.closest('[data-accessory-confirm],[data-accessory-direct]');if(!button) return;
    const card=cardFor(button); if(!card) return;
    const select=card.querySelector('[data-accessory-select]'), modal=panelFor(card);
    if(!select.value||button.disabled) return;
    if(card.hasAttribute('data-inline-screen')){
      selectVariant(card,select.value,true);modal.hide();return;
    }
    button.disabled=true;button.setAttribute('aria-busy','true');
    const error=panelFor(card).querySelector('[data-accessory-error]');error.hidden=true;
    try{
      await addItems([{id:Number(select.value),quantity:1}]);
      await modal.hide();
      card.hidden=true;
      document.getElementById('cart-drawer')?.show?.();
    }catch(err){
      error.hidden=false;error.textContent=err.message;
      if(!modal.hasAttribute('open')) modal.show();
      button.disabled=false;
    }finally{button.removeAttribute('aria-busy');}
  });
  let scheduled=false;
  const schedule=()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;init();});};
  window.addEventListener('pageshow',()=>{document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));schedule();});
  document.addEventListener('variant:change',schedule);
  document.addEventListener('roar:phone-model-change',schedule);
  document.addEventListener('dialog:after-show',event=>{if(event.target.id==='cart-drawer'){document.body.classList.add('rs-cart-open');document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));}});
  document.addEventListener('dialog:after-hide',event=>{if(event.target.id==='cart-drawer')document.body.classList.remove('rs-cart-open');});
  new MutationObserver(records=>{
    if(records.some(r=>r.type==='attributes')) schedule();
    if(records.some(r=>Array.from(r.addedNodes).some(n=>n.nodeType===1&&(n.matches?.('[data-accessory],[data-rs-money],product-rerender,cart-drawer')||n.querySelector?.('[data-accessory],[data-rs-money]'))))) schedule();
  }).observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['data-phone-model-confirmed','data-phone-model-state','open']});
  init();
})();

// Register the discount meter even when the cart is initially empty.

  if (!customElements.get('rs-case-discount-meter')) {
    customElements.define('rs-case-discount-meter', class CaseDiscountMeter extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        document.addEventListener('cart:change', (event) => this.update(event.detail?.cart), {
          signal: this.abortController.signal
        });
        document.addEventListener('cart:refresh', () => this.refresh(), {
          signal: this.abortController.signal
        });
        this.refresh();
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      async refresh() {
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });

          if (response.ok) {
            this.update(await response.json());
          }
        } catch (error) {
          console.warn('[case-discount-meter] Could not refresh cart.', error);
        }
      }

      update(cart) {
        if (!cart?.items) return;

        const qualifyingCount = cart.items.reduce((count, item) => {
          return this.isScreenProtector(item) ? count : count + Number(item.quantity || 0);
        }, 0);
        const stage = Math.min(qualifyingCount, 3);

        this.classList.remove(
          'case-discount-meter--stage-0',
          'case-discount-meter--stage-1',
          'case-discount-meter--stage-2',
          'case-discount-meter--stage-3'
        );
        this.classList.add(`case-discount-meter--stage-${stage}`);

        const message = this.querySelector('[data-discount-meter-message]');
        const detail = this.querySelector('[data-discount-meter-detail]');

        const swedish = this.dataset.language === 'sv';
        const danish = this.dataset.language === 'da';
        const finnish = this.dataset.language === 'fi';
        const texts = danish
          ? ['Tilføj 2 produkter – få 20 % på den billigste.', 'Tilføj 1 produkt – få 20 % på den billigste.', 'Tilføj 1 produkt – få 30 % på den billigste.', '✓ 30 % rabat på den billigste vare er anvendt.']
          : swedish
          ? ['Lägg till 2 produkter – få 20 % på den billigaste.', 'Lägg till 1 produkt – få 20 % på den billigaste.', 'Lägg till 1 produkt – få 30 % på den billigaste.', '✓ 30 % rabatt på den billigaste produkten är applicerad.']
          : finnish
          ? ['Lisää 2 tuotetta – saat edullisimmasta 20 % alennuksen.', 'Lisää 1 tuote – saat edullisimmasta 20 % alennuksen.', 'Lisää 1 tuote – saat edullisimmasta 30 % alennuksen.', '✓ Edullisimmasta tuotteesta on vähennetty 30 %.']
          : ['Add 2 products – get 20% off the cheapest.', 'Add 1 product – get 20% off the cheapest.', 'Add 1 product – get 30% off the cheapest.', '✓ 30% off the cheapest product has been applied.'];
        const eligibleItems = cart.items.filter((item) => !this.isScreenProtector(item));
        const cheapest = Math.min(...eligibleItems.map((item) => Number(item.original_price ?? item.price)));
        const expectedDiscount = qualifyingCount >= 3 ? Math.round(cheapest * .3) : qualifyingCount >= 2 ? Math.round(cheapest * .2) : 0;
        const allocations = cart.items.flatMap((item) => item.line_level_discount_allocations || item.discounts || []);
        const quantityAllocated = allocations.reduce((sum, allocation) => {
          const application = allocation.discount_application || allocation;
          const title = (application.title || '').toLowerCase().replace(/\s/g, '').replace(/[−–—]/g, '-');
          const quantityTitle = /^(?:3(?:→|->|:|-)|(?:köp|buy)3)/.test(title) && title.includes('30%');
          return application.type !== 'discount_code' && quantityTitle ? sum + Number(allocation.amount || 0) : sum;
        }, 0);
        const quantityApplied = stage === 3 && quantityAllocated > 0 && Math.abs(quantityAllocated - expectedDiscount) <= 1;
        const hasCode = allocations.some((allocation) => allocation.discount_application?.type === 'discount_code' && Number(allocation.amount) > 0)
          || (cart.cart_level_discount_applications || []).some((application) => application.type === 'discount_code' && Number(application.total_allocated_amount) > 0);
        let text = texts[stage];
        if (stage === 3 && !quantityApplied) {
          text = hasCode
            ? (this.dataset.codeAppliedDetail || (swedish ? 'Din rabattkod är applicerad. Se summeringen.' : 'Your discount code is applied. See the summary.'))
            : (this.dataset.unconfirmedDetail || (swedish ? 'Mängdrabatten är inte bekräftad. Se aktuell rabatt i summeringen.' : 'Quantity discount is not confirmed. See the current discount in the summary.'));
        }
        this.dataset.discountStatus = quantityApplied ? 'applied' : 'next';
        if (message) message.textContent = text;
        if (detail) detail.textContent = text;

        this.querySelectorAll('[data-discount-meter-step]').forEach((step) => {
          step.classList.toggle('is-active', stage >= Number(step.dataset.discountMeterStep));
        });
        this.querySelectorAll('[data-discount-meter-line]').forEach((line) => {
          line.classList.toggle('is-active', stage >= Number(line.dataset.discountMeterLine));
        });
      }

      isScreenProtector(item) {
        const searchable = [
          item.handle,
          item.product_type,
          item.product_title,
          item.title
        ].filter(Boolean).join(' ').toLowerCase();

        return item.gift_card === true
          || searchable.includes('presentkort')
          || searchable.includes('gift card')
          || searchable.includes('skärmskydd')
          || searchable.includes('skarmskydd')
          || searchable.includes('screen protector')
          || searchable.includes('screen-protector');
      }
    });
  }

/* Clear the basket deliberately; reset a remembered discount code as well. */
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-rs-clear-cart]');
  if (!button || button.disabled) return;
  const originalClearLabel = button.textContent;
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  const status = button.parentElement.querySelector('[data-rs-clear-error]');
  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + 'cart/clear.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}});
    if (!response.ok) throw new Error();
    const reset = await fetch(root + 'cart/update.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({discount:''})});
    if (!reset.ok) throw new Error();
    document.dispatchEvent(new CustomEvent('roar:cart-cleared'));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true}));
  } catch (error) {
    button.disabled = false;
    button.textContent = originalClearLabel;
    if (status) { status.hidden = false; status.textContent = button.dataset.clearError || ''; }
  } finally { button.removeAttribute('aria-busy'); }
});

/* Cart-only visual grouping: submits the original Shopify variant IDs. */
if (!customElements.get('rs-cart-accessory')) {
  customElements.define('rs-cart-accessory', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.dialog = this.querySelector('dialog');
      this.addEventListener('click', event => {
        if (event.target.closest('[data-strap-open]')) {
          this.updatePreview();
          this.dialog.showModal();
        }
        if (event.target.closest('[data-strap-close]')) this.dialog.close();
        if (event.target.closest('[data-strap-direct],[data-strap-add]')) this.add(event.target.closest('button'));
      });
      this.addEventListener('change', event => {
        if (event.target.matches('[data-strap-colour]')) this.updatePreview();
      });
      this.dialog?.addEventListener('keydown', event => {
        if (event.key === 'Escape') {event.preventDefault(); event.stopPropagation(); this.dialog.close();}
      });
      this.dialog?.addEventListener('cancel', event => {event.stopPropagation();});
      this.dialog?.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
      });
    }
    updatePreview() {
      const selected = this.querySelector('[data-strap-colour]:checked');
      const template = selected && this.querySelector('[data-strap-template="' + selected.value + '"]');
      if (template) {
        const preview = this.querySelector('[data-strap-preview]');
        preview.replaceChildren(template.content.cloneNode(true));
        preview.querySelectorAll('[data-rs-money]').forEach(el => {
          const cents = Number(el.dataset.rsMoney);
          el.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency', currency: window.Shopify.currency.active,
            minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2
          }).format(cents / 100);
        });
      }
    }
    async add(button) {
      if (this.busy) return;
      const id = this.dataset.directVariant || this.querySelector('[data-strap-colour]:checked')?.value;
      if (!id) return;
      this.busy = true;
      const buttons = [...this.querySelectorAll('button')];
      buttons.forEach(b => { b.disabled = true; });
      button.setAttribute('aria-busy', 'true');
      const status = this.querySelector('[data-strap-status]');
      const error = this.querySelector('[data-strap-error]');
      status.textContent = '';
      if (error) error.hidden = true;
      const items = [{id: Number(id), quantity: 1}];
      const adapter = this.querySelector('[data-strap-adapter]:checked');
      if (adapter) items.push({id: Number(adapter.value), quantity: 1});
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({items})
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || this.dataset.error);
        this.dialog?.close();
        status.textContent = this.dataset.success;
        this.querySelector('.rs-cart-accessory__row').hidden = true;
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
      } catch (err) {
        const message = err.message || this.dataset.error;
        if (this.dialog?.open && error) {error.textContent = message; error.hidden = false;}
        else status.textContent = message;
      } finally {
        this.busy = false;
        buttons.forEach(b => {b.disabled = false;});
        button.removeAttribute('aria-busy');
      }
    }
  });
}
